module.exports = __webpack_public_path__ + "img/GAME_SWEEPLEAVES2.eb9924f9.jpg";